export var GroupStatusesEnum;
(function (GroupStatusesEnum) {
    GroupStatusesEnum["PENDING"] = "Pending";
    GroupStatusesEnum["SUCCESS"] = "Success";
    GroupStatusesEnum["FAILED"] = "Failed";
})(GroupStatusesEnum || (GroupStatusesEnum = {}));
